import { render, staticRenderFns } from "./LawPoNumberList.vue?vue&type=template&id=ed618aa0&"
import script from "./LawPoNumberList.vue?vue&type=script&lang=js&"
export * from "./LawPoNumberList.vue?vue&type=script&lang=js&"
import style0 from "./LawPoNumberList.vue?vue&type=style&index=0&id=ed618aa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports